export default {
  not_started: 'Opsæt din udbetalingskonto – din indtægtsandel er sat på hold, indtil den er verificeret.',
  bank_account_missing: 'Tilføj en bankkonto til udbetalinger – din indtægtsandel er sat på hold, indtil du gør det.',
  incomplete:
    'Din udbetalingskonto er endnu ikke fuldt verificeret – din indtægtsandel er sat på hold, indtil den er det.',
  add_bank_account: 'Tilføj bankkonto',
  cta: 'Fuldfør opsætning',
};
